var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isHDCA } from "@/api";
import { fetcher } from "@/api/schema";
const DEFAULT_LIMIT = 50;
const getCollectionDetails = fetcher.path("/api/dataset_collections/{id}").method("get").create();
/**
 * Fetches the details of a collection.
 * @param params.id The ID of the collection (HDCA) to fetch.
 */
export function fetchCollectionDetails(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getCollectionDetails({ id: params.id });
        return data;
    });
}
const getCollectionContents = fetcher
    .path("/api/dataset_collections/{hdca_id}/contents/{parent_id}")
    .method("get")
    .create();
export function fetchCollectionElements(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getCollectionContents({
            instance_type: "history",
            hdca_id: params.hdcaId,
            parent_id: params.collectionId,
            offset: params.offset,
            limit: params.limit,
        });
        return data;
    });
}
export function fetchElementsFromCollection(params) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const hdcaId = isHDCA(params.entry) ? params.entry.id : params.entry.hdca_id;
        const collectionId = isHDCA(params.entry) ? params.entry.collection_id : params.entry.id;
        return fetchCollectionElements({
            hdcaId: hdcaId,
            collectionId: collectionId,
            offset: (_a = params.offset) !== null && _a !== void 0 ? _a : 0,
            limit: (_b = params.limit) !== null && _b !== void 0 ? _b : DEFAULT_LIMIT,
        });
    });
}
export const fetchCollectionAttributes = fetcher
    .path("/api/dataset_collections/{id}/attributes")
    .method("get")
    .create();
